module.exports = __webpack_public_path__ + "img/section3Logo2.ce339b1a.svg";